import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_257: DocMigration = {
  maxSchemaVersion: "0.0.257",
  description: "Rename FLOOR to FLOOR_PLAN",
  apply(json: any) {
    if (json.sheets) {
      for (const sheetId in json.sheets) {
        const sheet = json.sheets[sheetId];
        const { type } = sheet;
        if (type === "BACKGROUND") {
          const { background } = sheet;
          if (background === "FLOOR") {
            sheet.background = "FLOOR_PLAN";
          }
        } else {
          continue;
        }
        json.sheets[sheetId] = sheet;
      }
    }
    return json;
  },
};

export default migration_0_0_257;
